export default {
  SET_TIMEKIT_PROJECT_LIST: (state, { projectList }) => {
    state.projectList = projectList;
  },
  SET_MAGIC_OTP_LOADING: (state, { data }) => {
    state.magicOtpLoading = data;
  },
  SET_MAGIC_OTP_SAVING: (state, { data }) => {
    state.magicOtpSaving = data;
  },
  SET_MAGIC_OTP: (state, { data }) => {
    state.magicOtp = data;
  }
}
